import { useEffect, useState } from "react";

import PropTypes from "prop-types";

import { Autocomplete, CircularProgress } from "@mui/material";

import { apiClient } from "@/features/shared";
import { CustomInputField } from "@/features/ui";

// Cache for companies to avoid refetching
let companiesCache = null;
let companiesCachePromise = null;

const fetchCompaniesFromAPI = async () => {
  if (companiesCache) {
    return companiesCache;
  }

  if (companiesCachePromise) {
    return companiesCachePromise;
  }

  companiesCachePromise = apiClient
    .get("companies", { params: { size: 1000 } })
    .then(({ data: { data } }) => {
      companiesCache = data;
      companiesCachePromise = null;
      return data;
    })
    .catch((error) => {
      console.error("Error fetching companies:", error);
      companiesCachePromise = null;
      return [];
    });

  return companiesCachePromise;
};

export const CompanySelect = ({
  value,
  onChange,
  disabled,
  TextFieldProps,
  ...props
}) => {
  const [companies, setCompanies] = useState(companiesCache || []);
  const [loading, setLoading] = useState(!companiesCache);

  useEffect(() => {
    const loadCompanies = async () => {
      setLoading(true);
      const data = await fetchCompaniesFromAPI();
      setCompanies(data);
      setLoading(false);
    };

    loadCompanies();
  }, []); // Only fetch once on mount

  return (
    <Autocomplete
      value={value ?? null}
      onChange={(_, value) => onChange(value)}
      disabled={disabled || loading}
      options={companies}
      loading={loading}
      getOptionLabel={(option) => option?.name ?? ""}
      isOptionEqualToValue={(option, selectedOption) =>
        option.id === selectedOption.id
      }
      renderInput={(params) => (
        <CustomInputField
          {...TextFieldProps}
          {...params}
          InputProps={{
            placeholder:
              TextFieldProps?.InputProps?.placeholder || "Pilih Perusahaan",
            ...params.slotProps.input,
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.slotProps.input.endAdornment}
              </>
            ),
          }}
        />
      )}
      {...props}
    />
  );
};

CompanySelect.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  TextFieldProps: PropTypes.object,
};
